import React from "react";
import { CalendarCheckIcon, ClipboardListIcon, LineChartIcon, ListOrderedIcon, UsersIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { tools } from "../../data/landing";
const icons = {
  observation: {
    Icon: ClipboardListIcon,
    cls: "bg-sky text-white"
  },
  session: {
    Icon: CalendarCheckIcon,
    cls: "bg-mint text-white"
  },
  words: {
    Icon: ListOrderedIcon,
    cls: "bg-coral text-white"
  },
  family: {
    Icon: UsersIcon,
    cls: "bg-sun text-navy"
  },
  progress: {
    Icon: LineChartIcon,
    cls: "bg-lilac text-white"
  }
};
export function Tools() {
  return <Section className="bg-cream" data-id="element-288" data-mp="1yu36ux0ntfq4">
      <SectionHeading title="Practical tools included in the collection" intro="Alongside the six volumes, you'll receive practical tools designed to support different parts of your planning workflow." data-id="element-289" data-mp="1tugusqwki5iw" />

      <ul className="mx-auto mt-10 max-w-3xl divide-y-2 divide-navy/10 rounded-3xl bg-white px-5 shadow-[0_10px_30px_rgba(15,37,87,0.06)] sm:px-8" data-id="element-290" data-mp="1kt900it9fmtk">
        {tools.map(t => {
        const {
          Icon,
          cls
        } = icons[t.icon];
        return <li key={t.name} className="flex items-start gap-4 py-6" data-id="element-291" data-mp="1a1heuyuckc3g">
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${cls}`} data-id="element-292" data-mp="w9t695jb45r8">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-293" data-mp="10b6axcany2wk" />
              </span>
              <div data-id="element-294" data-mp="1o10ltobf9he6">
                <h3 className="font-display text-xl font-bold leading-snug text-navy" data-id="element-295" data-mp="1o0h3i6hv0qzm">{t.name}</h3>
                <p className="mt-1 text-[16px] leading-relaxed text-ink/80" data-id="element-296" data-mp="1syilsp7goma1">{t.body}</p>
              </div>
            </li>;
      })}
      </ul>

      <p className="mx-auto mt-6 max-w-2xl text-center text-sm font-semibold text-ink/70" data-id="element-297" data-mp="1jy40vqyet972">
        These are educational planning aids, not standardized assessment instruments or validated clinical protocols.
      </p>

      <div className="mt-10" data-id="element-298" data-mp="8jgvzo0l9wxh">
        <CTAButton label="Get the complete collection" data-id="element-299" data-mp="8kiay3kq73kh" />
      </div>
    </Section>;
}